module.exports = __webpack_public_path__ + "static/media/minus.0fc34add.png";